import React, { useMemo } from "react";
import { useRenderTier } from "../hooks/useRenderTier";

// Alleen te zien als het team het target haalt. De stukjes worden één keer
// bepaald, zodat de animatie niet opnieuw begint bij elke klok-tick.
//
// Deze bui houdt niet op: is het target gehaald, dan valt hij de rest van de
// maand door. Hoeveel snippers dat zijn komt van de kwaliteitstrap, want dit
// is beweging die op een trage Pi altijd meeloopt.

const colors = ["#ffffff", "#ffd166", "#ff9a3c", "#7fd8ff", "#cfeaff"];

const Confetti = ({ pieces }) => {
  const { fx } = useRenderTier();
  const count = pieces || fx.heroConfetti;

  const bits = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 6,
        duration: 4 + Math.random() * 4,
        size: 6 + Math.random() * 8,
        round: i % 3 === 0,
        color: colors[i % colors.length],
      })),
    [count],
  );

  return (
    <div className="confetti" aria-hidden="true">
      {bits.map((bit, i) => (
        <span
          key={i}
          className={`confetti-bit${bit.round ? " round" : ""}`}
          style={{
            left: `${bit.left}%`,
            width: `${bit.size}px`,
            height: `${bit.size * (bit.round ? 1 : 0.45)}px`,
            background: bit.color,
            animationDelay: `${bit.delay}s`,
            animationDuration: `${bit.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
